// This file is generated by pnpm icons:generate. Do not edit.

import {Attie_Filled_Corner0_Rounded as CanonicalAttie_Filled_Corner0_Rounded} from '../Attie'

/** @deprecated Import Attie_Filled_Corner0_Rounded from `#/components/icons/Attie` instead. */
export const Attie_Filled_Corner0_Rounded =
  CanonicalAttie_Filled_Corner0_Rounded
